var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-banner",on:{"click":function($event){return _vm.$router.push('/settings/general');}}},[_c('span',{staticClass:"icon"},[_vm._v("⚠️")]),_c('span',{staticClass:"text-banner-info"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }